import { useState, useEffect } from "react";

export const useWindowSize = () => {
  const [wh, setwh] = useState([
    window.innerWidth,
    window.innerHeight 
  ]);
  useEffect(() => {
    function handleResize() {
      setwh([
        window.innerWidth,
        window.innerHeight 
      ]);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return wh;
}